import { Component, computed, inject, input, resource } from '@angular/core';
import { Api } from '../../../../core/clients/portal/api';
import { getCsvFileContent } from '../../../../core/clients/portal/functions';
import { FileResponse } from '../../../../core/clients/omni-core/models';

@Component({
  selector: 'app-document-csv-table',

  templateUrl: './document-csv-table.html',
})
export class DocumentCsvTable {
  private api = inject(Api);

  document = input.required<FileResponse>();
  organizationID = input.required<string>();

  protected csvContent = resource({
    params: () => ({
      id: this.document().id,
      oid: this.organizationID(),
    }),
    loader: ({ params }) => this.api.invoke(getCsvFileContent, params),
  });

  protected headers = computed(() => {
    const d = this.csvContent.value();
    if (d?.headers && d.headers.length > 0) return d.headers;
    return [];
  });
  protected rows = computed<string[][]>(() => {
    const d = this.csvContent.value();
    const currentHeaders = this.headers();
    if (d?.rows) {
      return d.rows.map((row) => currentHeaders.map((h) => row[h] ?? ''));
    }
    return [];
  });
}
